module.exports = __webpack_public_path__ + "img/chat-ai-assistant.fb18f766.svg";